import React, { useEffect } from "react";
import Page from "../../layout/Page";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="Terms of Use - Shoora"
      description=""
      keywords="telematics, AI, IoT, fleet safety, road safety, logistics"
    >
      <div className="legal-header container py-3 border-bottom border-warning ">
        <h1 className="bold text-center">Terms of Use</h1>
      </div>
      <div className="container">
        <p>
          <strong>Effective Date</strong>: 1st January 2025
        </p>
        <p>
          Shoora.com is a property of MashEye Infotech Pvt. Ltd. (referred to as
          "Shoora," "we," "our," or "us"). These Terms of Use ("Terms") govern
          your access to and use of Shoora.com, including all services,
          products, and content available through the website. By accessing or
          using our website and products, you agree to comply with and be bound
          by these Terms. If you do not agree to these Terms, you should not use
          the website.
        </p>
        <h4>1. Acceptance of Terms</h4>
        <p>
          By using Shoora.com or any of Shoora's products and services, you
          confirm that you have read, understood, and agree to be bound by these
          Terms. Shoora may update or modify these Terms at any time without
          prior notice. Any changes will be posted on this page, and your
          continued use of the website will signify your acceptance of the
          modified Terms.
        </p>
        <h4>2. Use of Shoora.com</h4>
        <p>
          Shoora.com provides access to a variety of services, including but not
          limited to information on our products like the DSM Camera, ADAS
          Camera, and AI-enabled technology. You agree to use the website and
          its services only for lawful purposes and in accordance with these
          Terms.
        </p>

        <ul className="text-dark">
          <li className="text-dark">
            You may not use the website in any way that could damage, disable,
            or impair the functioning of the website or interfere with other
            users' access.
          </li>
          <li className="text-dark">
            You agree not to upload, post, or transmit any content that is
            unlawful, harmful, defamatory, invasive of privacy, or otherwise
            objectionable.
          </li>
          <li className="text-dark">
            You agree not to use the website for any purpose that could harm,
            exploit, or deceive minors or violate any applicable laws.
          </li>
        </ul>
        <h4>3. User Account and Security</h4>
        <p>
          To access certain features or services, you may need to create an
          account on Shoora.com. By creating an account, you agree to provide
          accurate, complete, and up-to-date information. You are responsible
          for maintaining the confidentiality of your account login credentials
          and are fully responsible for any activity that occurs under your
          account.
        </p>
        <p>
          If you believe your account has been compromised, you must immediately
          notify us and take steps to secure your account.
        </p>
        <h4>4. Shoora Products and Services</h4>
        <p>
          Shoora provides a variety of products and services, including:
          <ul className="text-dark">
            <li className="text-dark">
              <strong>DSM Camera:</strong> A driver monitoring system that
              detects fatigue, distraction, mobile usage, and other behaviors
              that may impair driving.
            </li>
            <li className="text-dark">
              <strong>ADAS Camera:</strong> Advanced Driver Assistance System
              (ADAS) cameras that offer features like Lane Departure Warning,
              Pedestrian Detection, and Forward Collision Warning.
            </li>
            <li className="text-dark">
              <strong>AI Technology:</strong> Our products incorporate AI
              technology to analyze data in real-time to improve driving safety.
            </li>
          </ul>
          By using Shoora's products, you agree to abide by any additional terms
          and conditions that may apply specifically to these products,
          including those related to data collection, usage, and privacy as
          outlined in our Privacy Policy.
        </p>
        <h4>5. Intellectual Property</h4>
        <p>
          All content on Shoora.com, including text, graphics, logos, images,
          audio clips, and software, is the property of Shoora or its licensors
          and is protected by copyright, trademark, and other intellectual
          property laws. You are granted a limited, non-exclusive,
          non-transferable license to access and use the website and its content
          for personal, non-commercial purposes. You may not copy, modify,
          distribute, or create derivative works based on any content from the
          website without the prior written consent of Shoora.
        </p>
        <h4>6. Privacy and Data Collection</h4>
        <p>
          By using Shoora.com, you acknowledge and agree to the collection and
          use of your data as described in our Privacy Policy. Shoora collects
          and processes personal data, device information, and data from our
          products, including the DSM Camera, ADAS Camera, and AI technology, to
          improve user experience and provide safety features.
        </p>
        <h4>7. Third-Party Links</h4>
        <p>
          Shoora.com may contain links to third-party websites or services that
          are not controlled by Shoora. We are not responsible for the content,
          privacy policies, or practices of any third-party sites. We encourage
          you to review the terms and privacy policies of any third-party
          websites before interacting with them.
        </p>
        <h4>8. Limitation of Liability</h4>
        <p>
          Shoora’s liability for any claims arising from the use of this website
          and its products is limited to the maximum extent permitted by law. In
          no event shall Shoora be liable for any indirect, incidental, special,
          or consequential damages, including loss of data or profits, arising
          out of or in connection with your use of the website or products.
        </p>
        <h4>9. Indemnification</h4>
        <p>
          You agree to indemnify and hold Shoora, its affiliates, employees,
          agents, and licensors harmless from any claims, damages, or expenses
          (including legal fees) arising out of your violation of these Terms or
          your use of Shoora.com and its products.
        </p>
        <h4>10. Termination</h4>
        <p>
          Shoora reserves the right to suspend or terminate your access to the
          website or any of its services at any time, without notice, for any
          reason, including but not limited to a violation of these Terms.
        </p>
        <h4>11. Governing Law</h4>
        <p>
          These Terms are governed by and construed in accordance with the laws
          of Haryana, India, without regard to its conflict of law principles.
          Any disputes arising out of or related to these Terms will be subject
          to the exclusive jurisdiction of the courts located in Gurugram,
          Haryana, India.
        </p>
        <h4>12. Changes to Terms</h4>
        <p>
          Shoora reserves the right to modify or update these Terms at any time.
          Any changes will be posted on this page with an updated effective
          date. It is your responsibility to review these Terms regularly to
          stay informed about any updates.
        </p>
        <h4>13. Contact Us</h4>
        <p>
          If you have any questions about these Terms or need further
          clarification, please contact us at:
        </p>
        <p></p>
        <p>
          <strong>Shoora.com</strong>
          <br />
          A Property of MashEye Infotech Pvt. Ltd. <br />
          Unit 914A, 9th Floor, BPTP Park Centra, Sector - 30, Gurugram - 122002{" "}
          <br />
          Email: info@shoora.com <br />
          Phone: +91 97287 46672
        </p>
        <p>
          By using Shoora’s website and services, you acknowledge that you have
          read, understood, and agree to these Terms of Use.
        </p>
      </div>
    </Page>
  );
};

export default TermsOfUse;
